import { render, staticRenderFns } from "./DetailSociete.vue?vue&type=template&id=224e9ca6&scoped=true&"
import script from "./DetailSociete.vue?vue&type=script&lang=js&"
export * from "./DetailSociete.vue?vue&type=script&lang=js&"
import style0 from "./DetailSociete.vue?vue&type=style&index=0&id=224e9ca6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224e9ca6",
  null
  
)

export default component.exports